import { SettingsHeader } from '../SettingsHeader';

export const Notification = () => {
  return (
    <div>
      <SettingsHeader title={'Notifications'} />
    </div>
  );
};
